// @flow
import type {
  ContactUsOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-contact-us'

// Libs
import composeOperator from 'fc-operations'

// Exports
export default function getContactUsOperator (): ContactUsOperator {
  return composeOperator({
    model: MODEL,
    branch: 'operation',
  })
}
